"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NG = void 0;
exports.NG = {
    numericCode: '566',
    alpha2Code: 'NG',
    alpha3Code: 'NGA',
    englishName: {
        short: 'Nigeria',
        full: 'the Federal Republic of Nigeria',
    },
    names: {
        full: {
            en: 'the Federal Republic of Nigeria',
            fr: 'la République fédérale du Nigéria',
        },
        short: {
            en: 'Nigeria',
            fr: 'Nigéria (le)',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'NG-AB': {
            numericCode: '566',
            code: 'NG-AB',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Abia',
            },
        },
        'NG-AD': {
            numericCode: '566',
            code: 'NG-AD',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Adamawa',
            },
        },
        'NG-AK': {
            numericCode: '566',
            code: 'NG-AK',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Akwa Ibom',
            },
        },
        'NG-AN': {
            numericCode: '566',
            code: 'NG-AN',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Anambra',
            },
        },
        'NG-BA': {
            numericCode: '566',
            code: 'NG-BA',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Bauchi',
            },
        },
        'NG-BE': {
            numericCode: '566',
            code: 'NG-BE',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Benue',
            },
        },
        'NG-BO': {
            numericCode: '566',
            code: 'NG-BO',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Borno',
            },
        },
        'NG-BY': {
            numericCode: '566',
            code: 'NG-BY',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Bayelsa',
            },
        },
        'NG-CR': {
            numericCode: '566',
            code: 'NG-CR',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Cross River',
            },
        },
        'NG-DE': {
            numericCode: '566',
            code: 'NG-DE',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Delta',
            },
        },
        'NG-EB': {
            numericCode: '566',
            code: 'NG-EB',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Ebonyi',
            },
        },
        'NG-ED': {
            numericCode: '566',
            code: 'NG-ED',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Edo',
            },
        },
        'NG-EK': {
            numericCode: '566',
            code: 'NG-EK',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Ekiti',
            },
        },
        'NG-EN': {
            numericCode: '566',
            code: 'NG-EN',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Enugu',
            },
        },
        'NG-GO': {
            numericCode: '566',
            code: 'NG-GO',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Gombe',
            },
        },
        'NG-IM': {
            numericCode: '566',
            code: 'NG-IM',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Imo',
            },
        },
        'NG-JI': {
            numericCode: '566',
            code: 'NG-JI',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Jigawa',
            },
        },
        'NG-KD': {
            numericCode: '566',
            code: 'NG-KD',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kaduna',
            },
        },
        'NG-KE': {
            numericCode: '566',
            code: 'NG-KE',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kebbi',
            },
        },
        'NG-KN': {
            numericCode: '566',
            code: 'NG-KN',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kano',
            },
        },
        'NG-KO': {
            numericCode: '566',
            code: 'NG-KO',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kogi',
            },
        },
        'NG-KT': {
            numericCode: '566',
            code: 'NG-KT',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Katsina',
            },
        },
        'NG-KW': {
            numericCode: '566',
            code: 'NG-KW',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kwara',
            },
        },
        'NG-LA': {
            numericCode: '566',
            code: 'NG-LA',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Lagos',
            },
        },
        'NG-NA': {
            numericCode: '566',
            code: 'NG-NA',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Nasarawa',
            },
        },
        'NG-NI': {
            numericCode: '566',
            code: 'NG-NI',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Niger',
            },
        },
        'NG-OG': {
            numericCode: '566',
            code: 'NG-OG',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Ogun',
            },
        },
        'NG-ON': {
            numericCode: '566',
            code: 'NG-ON',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Ondo',
            },
        },
        'NG-OS': {
            numericCode: '566',
            code: 'NG-OS',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Osun',
            },
        },
        'NG-OY': {
            numericCode: '566',
            code: 'NG-OY',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Oyo',
            },
        },
        'NG-PL': {
            numericCode: '566',
            code: 'NG-PL',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Plateau',
            },
        },
        'NG-RI': {
            numericCode: '566',
            code: 'NG-RI',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Rivers',
            },
        },
        'NG-SO': {
            numericCode: '566',
            code: 'NG-SO',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Sokoto',
            },
        },
        'NG-TA': {
            numericCode: '566',
            code: 'NG-TA',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Taraba',
            },
        },
        'NG-YO': {
            numericCode: '566',
            code: 'NG-YO',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Yobe',
            },
        },
        'NG-ZA': {
            numericCode: '566',
            code: 'NG-ZA',
            category: {
                id: '200',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Zamfara',
            },
        },
        'NG-FC': {
            numericCode: '566',
            code: 'NG-FC',
            category: {
                id: '435',
                names: {
                    en: {
                        singular: 'capital territory',
                        plural: 'capital territories',
                    },
                    fr: {
                        singular: 'territoire de la capitale',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Abuja Federal Capital Territory',
            },
        },
    },
    cities: [
        {
            name: 'Zuru',
            subdivision: 'Kebbi',
        },
        {
            name: 'Zungeru',
            subdivision: 'Niger',
        },
        {
            name: 'Zaria',
            subdivision: 'Kaduna',
        },
        {
            name: 'Yola',
            subdivision: 'Adamawa',
        },
        {
            name: 'Yenagoa',
            subdivision: 'Bayelsa',
        },
        {
            name: 'Wukari',
            subdivision: 'Taraba',
        },
        {
            name: 'Wudil',
            subdivision: 'Kano',
        },
        {
            name: 'Warri',
            subdivision: 'Delta',
        },
        {
            name: 'Wamba',
            subdivision: 'Nassarawa',
        },
        {
            name: 'Uyo',
            subdivision: 'Akwa Ibom',
        },
        {
            name: 'Uromi',
            subdivision: 'Edo',
        },
        {
            name: 'Umuahia',
            subdivision: 'Abia',
        },
        {
            name: 'Ughelli',
            subdivision: 'Delta',
        },
        {
            name: 'Ugep',
            subdivision: 'Cross River',
        },
        {
            name: 'Uga',
            subdivision: 'Anambra',
        },
        {
            name: 'Ubiaja',
            subdivision: 'Edo',
        },
        {
            name: 'Tegina',
            subdivision: 'Niger',
        },
        {
            name: 'Tambuwal',
            subdivision: 'Sokoto',
        },
        {
            name: 'Talata Mafara',
            subdivision: 'Zamfara',
        },
        {
            name: 'Takum',
            subdivision: 'Benue',
        },
        {
            name: 'Suleja',
            subdivision: 'Niger',
        },
        {
            name: 'Sokoto',
            subdivision: 'Sokoto',
        },
        {
            name: 'Soba',
            subdivision: 'Kaduna',
        },
        {
            name: 'Saki',
            subdivision: 'Oyo',
        },
        {
            name: 'Shagamu',
            subdivision: 'Ogun',
        },
        {
            name: 'Sapele',
            subdivision: 'Delta',
        },
        {
            name: 'Rijau',
            subdivision: 'Niger',
        },
        {
            name: 'Rano',
            subdivision: 'Kano',
        },
        {
            name: 'Potiskum',
            subdivision: 'Yobe',
        },
        {
            name: 'Port Harcourt',
            subdivision: 'Rivers',
        },
        {
            name: 'Pindiga',
            subdivision: 'Gombe',
        },
        {
            name: 'Patigi',
            subdivision: 'Kwara',
        },
        {
            name: 'Pankshin',
            subdivision: 'Plateau',
        },
        {
            name: 'Ozubulu',
            subdivision: 'Anambra',
        },
        {
            name: 'Oyo',
            subdivision: 'Oyo',
        },
        {
            name: 'Oyan',
            subdivision: 'Osun',
        },
        {
            name: 'Owo',
            subdivision: 'Ondo',
        },
        {
            name: 'Owerri',
            subdivision: 'Imo',
        },
        {
            name: 'Otukpa',
            subdivision: 'Benue',
        },
        {
            name: 'Otan Ayegbaju',
            subdivision: 'Osun',
        },
        {
            name: 'Osogbo',
            subdivision: 'Osun',
        },
        {
            name: 'Orita Eruwa',
            subdivision: 'Oyo',
        },
        {
            name: 'Onitsha',
            subdivision: 'Anambra',
        },
        {
            name: 'Ondo',
            subdivision: 'Ondo',
        },
        {
            name: 'Olupona',
            subdivision: 'Osun',
        },
        {
            name: 'Okuta',
            subdivision: 'Kwara',
        },
        {
            name: 'Okrika',
            subdivision: 'Rivers',
        },
        {
            name: 'Okigwe',
            subdivision: 'Imo',
        },
        {
            name: 'Okene',
            subdivision: 'Kogi',
        },
        {
            name: 'Oke Mesi',
            subdivision: 'Osun',
        },
        {
            name: 'Oke Ila',
            subdivision: 'Ekiti',
        },
        {
            name: 'Ohafia-Ifigh',
            subdivision: 'Abia',
        },
        {
            name: 'Ogwashi-Uku',
            subdivision: 'Delta',
        },
        {
            name: 'Oguta',
            subdivision: 'Imo',
        },
        {
            name: 'Ogoja',
            subdivision: 'Cross River',
        },
        {
            name: 'Ogaminana',
            subdivision: 'Kogi',
        },
        {
            name: 'Offa',
            subdivision: 'Kwara',
        },
        {
            name: 'Ode',
            subdivision: 'Ondo',
        },
        {
            name: 'Obudu',
            subdivision: 'Cross River',
        },
        {
            name: 'Obonoma',
            subdivision: 'Rivers',
        },
        {
            name: 'Numan',
            subdivision: 'Adamawa',
        },
        {
            name: 'Nsukka',
            subdivision: 'Enugu',
        },
        {
            name: 'Nnewi',
            subdivision: 'Anambra',
        },
        {
            name: 'Nkwerre',
            subdivision: 'Imo',
        },
        {
            name: 'Nkpor',
            subdivision: 'Anambra',
        },
        {
            name: 'Nguru',
            subdivision: 'Yobe',
        },
        {
            name: 'Nasarawa',
            subdivision: 'Nassarawa',
        },
        {
            name: 'Nafada',
            subdivision: 'Gombe',
        },
        {
            name: 'Mubi',
            subdivision: 'Adamawa',
        },
        {
            name: 'Moriki',
            subdivision: 'Zamfara',
        },
        {
            name: 'Monguno',
            subdivision: 'Borno',
        },
        {
            name: 'Mokwa',
            subdivision: 'Niger',
        },
        {
            name: 'Modakeke',
            subdivision: 'Osun',
        },
        {
            name: 'Minna',
            subdivision: 'Niger',
        },
        {
            name: 'Marte',
            subdivision: 'Borno',
        },
        {
            name: 'Malumfashi',
            subdivision: 'Katsina',
        },
        {
            name: 'Makurdi',
            subdivision: 'Benue',
        },
        {
            name: 'Makoko',
            subdivision: 'Lagos',
        },
        {
            name: 'Maiduguri',
            subdivision: 'Borno',
        },
        {
            name: 'Magumeri',
            subdivision: 'Borno',
        },
        {
            name: 'Lokoja',
            subdivision: 'Kogi',
        },
        {
            name: 'Lere',
            subdivision: 'Kaduna',
        },
        {
            name: 'Lapai',
            subdivision: 'Niger',
        },
        {
            name: 'Lalupon',
            subdivision: 'Oyo',
        },
        {
            name: 'Lagos',
            subdivision: 'Lagos',
        },
        {
            name: 'Lafiagi',
            subdivision: 'Kwara',
        },
        {
            name: 'Lafia',
            subdivision: 'Nassarawa',
        },
        {
            name: 'Kwale',
            subdivision: 'Delta',
        },
        {
            name: 'Kumo',
            subdivision: 'Gombe',
        },
        {
            name: 'Kumagunnam',
            subdivision: 'Yobe',
        },
        {
            name: 'Kukawa',
            subdivision: 'Borno',
        },
        {
            name: 'Kuje',
            subdivision: 'Abuja Federal Capital Territory',
        },
        {
            name: 'Kontagora',
            subdivision: 'Niger',
        },
        {
            name: 'Kiyawa',
            subdivision: 'Jigawa',
        },
        {
            name: 'Kisi',
            subdivision: 'Oyo',
        },
        {
            name: 'Keffi',
            subdivision: 'Nassarawa',
        },
        {
            name: 'Kaura Namoda',
            subdivision: 'Zamfara',
        },
        {
            name: 'Katsina-Ala',
            subdivision: 'Benue',
        },
        {
            name: 'Katsina',
            subdivision: 'Katsina',
        },
        {
            name: 'Kari',
            subdivision: 'Bauchi',
        },
        {
            name: 'Kano',
            subdivision: 'Kano',
        },
        {
            name: 'Kamba',
            subdivision: 'Kebbi',
        },
        {
            name: 'Kaiama',
            subdivision: 'Kwara',
        },
        {
            name: 'Kagoro',
            subdivision: 'Kaduna',
        },
        {
            name: 'Kafanchan',
            subdivision: 'Kaduna',
        },
        {
            name: 'Kaduna',
            subdivision: 'Kaduna',
        },
        {
            name: 'Kachia',
            subdivision: 'Kaduna',
        },
        {
            name: 'Kabba',
            subdivision: 'Kogi',
        },
        {
            name: 'Jos',
            subdivision: 'Plateau',
        },
        {
            name: 'Jimeta',
            subdivision: 'Adamawa',
        },
        {
            name: 'Jega',
            subdivision: 'Kebbi',
        },
        {
            name: 'Jebba',
            subdivision: 'Kwara',
        },
        {
            name: 'Jalingo',
            subdivision: 'Taraba',
        },
        {
            name: 'Iwo',
            subdivision: 'Osun',
        },
        {
            name: 'Itu',
            subdivision: 'Akwa Ibom',
        },
        {
            name: 'Isieke',
            subdivision: 'Ebonyi',
        },
        {
            name: 'Ise-Ekiti',
            subdivision: 'Ekiti',
        },
        {
            name: 'Isanlu-Itedoijowa',
            subdivision: 'Kogi',
        },
        {
            name: 'Ipoti',
            subdivision: 'Ekiti',
        },
        {
            name: 'Iperu',
            subdivision: 'Ogun',
        },
        {
            name: 'Inisa',
            subdivision: 'Osun',
        },
        {
            name: 'Ilorin',
            subdivision: 'Kwara',
        },
        {
            name: 'Ilobu',
            subdivision: 'Osun',
        },
        {
            name: 'Illela',
            subdivision: 'Sokoto',
        },
        {
            name: 'Ilesa',
            subdivision: 'Osun',
        },
        {
            name: 'Ilaro',
            subdivision: 'Ogun',
        },
        {
            name: 'Ila Orangun',
            subdivision: 'Osun',
        },
        {
            name: 'Ikot Ekpene',
            subdivision: 'Akwa Ibom',
        },
        {
            name: 'Ikom',
            subdivision: 'Cross River',
        },
        {
            name: 'Ikirun',
            subdivision: 'Osun',
        },
        {
            name: 'Ikire',
            subdivision: 'Osun',
        },
        {
            name: 'Ikere-Ekiti',
            subdivision: 'Ekiti',
        },
        {
            name: 'Ikeja',
            subdivision: 'Lagos',
        },
        {
            name: 'Ijero-Ekiti',
            subdivision: 'Ekiti',
        },
        {
            name: 'Ijebu-Ode',
            subdivision: 'Ogun',
        },
        {
            name: 'Ijebu-Jesa',
            subdivision: 'Osun',
        },
        {
            name: 'Ijebu-Igbo',
            subdivision: 'Ogun',
        },
        {
            name: 'Ihiala',
            subdivision: 'Anambra',
        },
        {
            name: 'Igede-Ekiti',
            subdivision: 'Ekiti',
        },
        {
            name: 'Igbo-Ukwu',
            subdivision: 'Anambra',
        },
        {
            name: 'Igbor',
            subdivision: 'Benue',
        },
        {
            name: 'Igbo-Ora',
            subdivision: 'Oyo',
        },
        {
            name: 'Igboho',
            subdivision: 'Oyo',
        },
        {
            name: 'Igbeti',
            subdivision: 'Oyo',
        },
        {
            name: 'Igbara-Odo',
            subdivision: 'Ekiti',
        },
        {
            name: 'Ifo',
            subdivision: 'Ogun',
        },
        {
            name: 'Idanre',
            subdivision: 'Ondo',
        },
        {
            name: 'Idah',
            subdivision: 'Kogi',
        },
        {
            name: 'Ibi',
            subdivision: 'Taraba',
        },
        {
            name: 'Ibeto',
            subdivision: 'Niger',
        },
        {
            name: 'Ibadan',
            subdivision: 'Oyo',
        },
        {
            name: 'Hadejia',
            subdivision: 'Jigawa',
        },
        {
            name: 'Gwoza',
            subdivision: 'Borno',
        },
        {
            name: 'Gwarzo',
            subdivision: 'Kano',
        },
        {
            name: 'Gwaram',
            subdivision: 'Jigawa',
        },
        {
            name: 'Gwadabawa',
            subdivision: 'Sokoto',
        },
        {
            name: 'Gusau',
            subdivision: 'Zamfara',
        },
        {
            name: 'Gummi',
            subdivision: 'Zamfara',
        },
        {
            name: 'Gumel',
            subdivision: 'Jigawa',
        },
        {
            name: 'Gombi',
            subdivision: 'Adamawa',
        },
        {
            name: 'Gombe',
            subdivision: 'Gombe',
        },
        {
            name: 'Gembu',
            subdivision: 'Taraba',
        },
        {
            name: 'Geidam',
            subdivision: 'Yobe',
        },
        {
            name: 'Gbongan',
            subdivision: 'Osun',
        },
        {
            name: 'Gaya',
            subdivision: 'Kano',
        },
        {
            name: 'Gashua',
            subdivision: 'Yobe',
        },
        {
            name: 'Garko',
            subdivision: 'Gombe',
        },
        {
            name: 'Ganye',
            subdivision: 'Adamawa',
        },
        {
            name: 'Gamboru',
            subdivision: 'Borno',
        },
        {
            name: 'Funtua',
            subdivision: 'Katsina',
        },
        {
            name: 'Fiditi',
            subdivision: 'Oyo',
        },
        {
            name: 'Ezza-Ohu',
            subdivision: 'Ebonyi',
        },
        {
            name: 'Esuk Oron',
            subdivision: 'Akwa Ibom',
        },
        {
            name: 'Epe',
            subdivision: 'Lagos',
        },
        {
            name: 'Enugu-Ukwu',
            subdivision: 'Anambra',
        },
        {
            name: 'Enugu-Ezike',
            subdivision: 'Enugu',
        },
        {
            name: 'Enugu',
            subdivision: 'Enugu',
        },
        {
            name: 'Emure-Ekiti',
            subdivision: 'Ekiti',
        },
        {
            name: 'Elele',
            subdivision: 'Rivers',
        },
        {
            name: 'Ekpoma',
            subdivision: 'Edo',
        },
        {
            name: 'Eket',
            subdivision: 'Akwa Ibom',
        },
        {
            name: 'Ejigbo',
            subdivision: 'Osun',
        },
        {
            name: 'Eha Amufu',
            subdivision: 'Enugu',
        },
        {
            name: 'Egbe',
            subdivision: 'Kogi',
        },
        {
            name: 'Effon Alaiye',
            subdivision: 'Osun',
        },
        {
            name: 'Effium',
            subdivision: 'Ebonyi',
        },
        {
            name: 'Ebute Ikorodu',
            subdivision: 'Lagos',
        },
        {
            name: 'Dutsen Wai',
            subdivision: 'Kaduna',
        },
        {
            name: 'Dutse',
            subdivision: 'Jigawa',
        },
        {
            name: 'Dukku',
            subdivision: 'Gombe',
        },
        {
            name: 'Doma',
            subdivision: 'Nassarawa',
        },
        {
            name: 'Dikwa',
            subdivision: 'Borno',
        },
        {
            name: 'Deba',
            subdivision: 'Gombe',
        },
        {
            name: 'Daura',
            subdivision: 'Katsina',
        },
        {
            name: 'Daura',
            subdivision: 'Yobe',
        },
        {
            name: 'Darazo',
            subdivision: 'Bauchi',
        },
        {
            name: 'Damboa',
            subdivision: 'Borno',
        },
        {
            name: 'Damaturu',
            subdivision: 'Yobe',
        },
        {
            name: 'Calabar',
            subdivision: 'Cross River',
        },
        {
            name: 'Burutu',
            subdivision: 'Delta',
        },
        {
            name: 'Bukuru',
            subdivision: 'Plateau',
        },
        {
            name: 'Buguma',
            subdivision: 'Rivers',
        },
        {
            name: 'Bonny',
            subdivision: 'Rivers',
        },
        {
            name: 'Bode Saadu',
            subdivision: 'Kwara',
        },
        {
            name: 'Biu',
            subdivision: 'Borno',
        },
        {
            name: 'Birnin Kudu',
            subdivision: 'Jigawa',
        },
        {
            name: 'Birnin Kebbi',
            subdivision: 'Kebbi',
        },
        {
            name: 'Sofo-Birnin-Gwari',
            subdivision: 'Kaduna',
        },
        {
            name: 'Billiri',
            subdivision: 'Gombe',
        },
        {
            name: 'Bida',
            subdivision: 'Niger',
        },
        {
            name: 'Benin City',
            subdivision: 'Edo',
        },
        {
            name: 'Bende',
            subdivision: 'Abia',
        },
        {
            name: 'Beli',
            subdivision: 'Taraba',
        },
        {
            name: 'Bauchi',
            subdivision: 'Bauchi',
        },
        {
            name: 'Baro',
            subdivision: 'Niger',
        },
        {
            name: 'Bama',
            subdivision: 'Borno',
        },
        {
            name: 'Badagry',
            subdivision: 'Lagos',
        },
        {
            name: 'Babana',
            subdivision: 'Niger',
        },
        {
            name: 'Azare',
            subdivision: 'Bauchi',
        },
        {
            name: 'Awka',
            subdivision: 'Anambra',
        },
        {
            name: 'Awgu',
            subdivision: 'Enugu',
        },
        {
            name: 'Auchi',
            subdivision: 'Edo',
        },
        {
            name: 'Asaba',
            subdivision: 'Delta',
        },
        {
            name: 'Argungu',
            subdivision: 'Kebbi',
        },
        {
            name: 'Aramoko-Ekiti',
            subdivision: 'Ekiti',
        },
        {
            name: 'Apomu',
            subdivision: 'Osun',
        },
        {
            name: 'Anchau',
            subdivision: 'Kaduna',
        },
        {
            name: 'Amaigbo',
            subdivision: 'Abia',
        },
        {
            name: 'Akwanga',
            subdivision: 'Nassarawa',
        },
        {
            name: 'Akure',
            subdivision: 'Ondo',
        },
        {
            name: 'Aku',
            subdivision: 'Enugu',
        },
        {
            name: 'Ajaokuta',
            subdivision: 'Kogi',
        },
        {
            name: 'Agulu',
            subdivision: 'Anambra',
        },
        {
            name: 'Agbor',
            subdivision: 'Delta',
        },
        {
            name: 'Afikpo',
            subdivision: 'Ebonyi',
        },
        {
            name: 'Ado Odo',
            subdivision: 'Ogun',
        },
        {
            name: 'Ado-Ekiti',
            subdivision: 'Ekiti',
        },
        {
            name: 'Abuja',
            subdivision: 'Abuja Federal Capital Territory',
        },
        {
            name: 'Abeokuta',
            subdivision: 'Ogun',
        },
        {
            name: 'Abakaliki',
            subdivision: 'Ebonyi',
        },
        {
            name: 'Aba',
            subdivision: 'Abia',
        },
        {
            name: 'Degema Hulk',
            subdivision: 'Rivers',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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